import React from "react";
import { Tabs } from "@ann/web-components";
import { TabsContainer } from "./Tabs.styled";
import { WorkspaceDetailsTabsEnum } from "../../enums/workspaceDetailsTabs";

const WorkspaceDetailsTabs = ({ onTabChange, defaultIndex = WorkspaceDetailsTabsEnum.OVERVIEW }) => {
  const handleTabChange = (index) => {
    if (onTabChange) {
      onTabChange(index);
    }
  };

  return (
    <TabsContainer>
      <Tabs defaultIndex={defaultIndex} size="medium" onChange={handleTabChange}>
        <Tabs.List>
          <Tabs.Tab iconLeft="short_text" index={WorkspaceDetailsTabsEnum.OVERVIEW}>
            Overview
          </Tabs.Tab>
          <Tabs.Tab iconLeft="person" index={WorkspaceDetailsTabsEnum.USERS}>
            Users
          </Tabs.Tab>
          <Tabs.Tab iconLeft="list" index={WorkspaceDetailsTabsEnum.ACTIVITY_LOG}>
            Activity Log
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
    </TabsContainer>
  );
};

export default WorkspaceDetailsTabs;

